module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('div', {
    staticClass: "activity-detail-top"
  }, [_c('div', {
    staticClass: "top-info"
  }, [_c('div', {
    staticClass: "info-top-box"
  }, [_c('div', {
    staticClass: "activity-detail-title"
  }, [_vm._v(_vm._s(_vm.row.title))]), _vm._v(" "), _c('div', {
    staticClass: "activity-detail-desc"
  }, [_vm._v(_vm._s(_vm.row.desc))])]), _vm._v(" "), _c('div', {
    staticClass: "info-main-box"
  }, [_c('div', {
    staticClass: "activity-dynamic"
  }, [_c('span', [_vm._v("动态")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.row.bbs_content_count))]), _vm._v(" ·\n                  "), _c('span', [_vm._v("互动")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.row.bbs_activity_count))])]), _vm._v(" "), _c('div', {
    staticClass: "info-dynamic-items"
  }, [(_vm.row.type_id > 0) ? _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'SaiFilesList',
        query: {
          saiqu: _vm.row.type_id
        }
      }),
      expression: "{name:'SaiFilesList',query:{saiqu:row.type_id}}"
    }],
    staticClass: "dynamic-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/pic-shuo-1@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item-title"
  }, [_vm._v("通知文件")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/pic-shuo-10@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item-title"
  }, [_vm._v("日程表")])]), _vm._v(" "), (_vm.row.type_id > 0) ? _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'SaiStartList',
        query: {
          saiqu: _vm.row.type_id
        }
      }),
      expression: "{name:'SaiStartList',query:{saiqu:row.type_id}}"
    }],
    staticClass: "dynamic-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/pic-shuo-2@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item-title"
  }, [_vm._v("出场顺序")])]) : _vm._e(), _vm._v(" "), (_vm.row.type_id > 0) ? _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'SaiResult',
        query: {
          saiqu: _vm.row.type_id
        }
      }),
      expression: "{name:'SaiResult',query:{saiqu:row.type_id}}"
    }],
    staticClass: "dynamic-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/pic-shuo-4@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item-title"
  }, [_vm._v("成绩查询")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item",
    on: {
      "click": function($event) {
        return _vm.onShisu()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/pic-shuo-9@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item-title"
  }, [_vm._v("食宿安排")])]), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item",
    on: {
      "click": function($event) {
        return _vm.onResults()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/pic-shuo-5@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item-title"
  }, [_vm._v("成绩册下载")])]), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item",
    on: {
      "click": function($event) {
        return _vm.onZhixuce()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/pic-shuo-6@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item-title"
  }, [_vm._v("秩序册下载")])]), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item",
    on: {
      "click": function($event) {
        return _vm.onWenjuan()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/pic-shuo-7@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item-title"
  }, [_vm._v("调查问卷")])]), _vm._v(" "), (_vm.row.type_id > 0) ? _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyFormStep1',
        query: {
          saiqu_id: _vm.row.type_id
        }
      }),
      expression: "{name:'ISaiApplyFormStep1',query:{saiqu_id:row.type_id}}"
    }],
    staticClass: "dynamic-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/pic-shuo-8@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item-title"
  }, [_vm._v("立即报名")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item",
    on: {
      "click": function($event) {
        return _vm.onZhibo()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/pic-shuo-3@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item-title"
  }, [_vm._v("直播")])])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "info-bottom-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/icon-shuo-notice@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "1px",
      "height": "15px",
      "background": "rgba(0,0,0,1)",
      "opacity": "0.16"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "start-immediately"
  }, [_vm._v("赛事马上开始咯~")])]) : _vm._e()])]), _vm._v(" "), _c('van-tabs', {
    staticClass: "active-tab",
    attrs: {
      "sticky": ""
    },
    on: {
      "click": _vm.onClick
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, _vm._l((_vm.activeTab), function(item, index) {
    return _c('van-tab', {
      key: index,
      attrs: {
        "type": index
      },
      scopedSlots: _vm._u([{
        key: "title",
        fn: function() {
          return [(item.num > 0) ? _c('span', {
            staticClass: "active-tab-num"
          }, [_vm._v(_vm._s(item.num))]) : _vm._e(), _vm._v("\n                " + _vm._s(item.name) + "\n              ")]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _vm._l((_vm.row.list.list), function(item, i) {
      return _c('div', [(item.style == '1') ? _c('Activity1', {
        attrs: {
          "content": item,
          "index": i
        }
      }) : _vm._e(), _vm._v(" "), (item.style == '2') ? _c('Activity2', {
        attrs: {
          "content": item,
          "index": i
        }
      }) : _vm._e(), _vm._v(" "), (item.style == '3') ? _c('Activity3', {
        attrs: {
          "content": item,
          "index": i
        },
        on: {
          "sendBox": function($event) {
            return _vm.onSendBox($event, item, i)
          },
          "loginStatus": function($event) {
            return _vm.onLoginStatus($event)
          },
          "deleteActive": function($event) {
            return _vm.onDeleteActive($event, item, i)
          },
          "deleteComment": function($event) {
            return _vm.onDeleteComment($event, i)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.style == '4') ? _c('Activity4', {
        attrs: {
          "content": item,
          "index": i
        },
        on: {
          "sendBox": function($event) {
            return _vm.onSendBox($event, item, i)
          },
          "loginStatus": function($event) {
            return _vm.onLoginStatus($event)
          },
          "deleteActive": function($event) {
            return _vm.onDeleteActive($event, item, i)
          },
          "deleteComment": function($event) {
            return _vm.onDeleteComment($event, i)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.style == '5') ? _c('Activity5', {
        attrs: {
          "content": item,
          "index": i
        },
        on: {
          "sendBox": function($event) {
            return _vm.onSendBox($event, item, i)
          },
          "loginStatus": function($event) {
            return _vm.onLoginStatus($event)
          },
          "deleteActive": function($event) {
            return _vm.onDeleteActive($event, item, i)
          },
          "deleteComment": function($event) {
            return _vm.onDeleteComment($event, i)
          }
        }
      }) : _vm._e()], 1)
    })], 2)
  }), 1), _vm._v(" "), (_vm.sendShow) ? _c('div', {
    staticClass: "comment-bottom"
  }, [_c('div', {
    staticClass: "send-comment"
  }, [_c('van-field', {
    attrs: {
      "placeholder": _vm.placeholder,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "send-btn",
    on: {
      "click": _vm.onCommentSend
    }
  }, [_vm._v("发送")])], 1)]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ActivityContentForm',
        query: {
          'activity_id': this.$route.query.id
        }
      }),
      expression: "{name:'ActivityContentForm',query:{'activity_id':this.$route.query.id}}"
    }],
    staticClass: "to-form-add"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/bg-btn-post@2x.png"),
      "alt": "",
      "srcset": ""
    }
  })]), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.sheetActiveActions,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "cancel": _vm.onSheetCancel,
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.sheetActiveShow),
      callback: function($$v) {
        _vm.sheetActiveShow = $$v
      },
      expression: "sheetActiveShow"
    }
  }), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.sheetCommentActions,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "cancel": _vm.onSheetCancel,
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.sheetCommentShow),
      callback: function($$v) {
        _vm.sheetCommentShow = $$v
      },
      expression: "sheetCommentShow"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-752497d1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/activity/Activity.vue
// module id = 1286
// module chunks = 0